"use client";

import { MouseEvent, ReactNode, useCallback, useState } from "react";
import { useRouter } from "next/navigation";
import { getOptionalMe } from "@/features/auth/api";
import { useAuthPromptStore } from "@/store/useAppStore";

export function useAuthGate() {
  const openAuthPrompt = useAuthPromptStore((state) => state.openAuthPrompt);
  return useCallback(async (returnTo: string, action: () => void, message?: string) => {
    try { if (await getOptionalMe()) return action(); } catch { /* 보호 기능은 인증 확인 실패 시 실행하지 않는다. */ }
    openAuthPrompt(returnTo, message);
  }, [openAuthPrompt]);
}

export function AuthRequiredLink({ href, children, className, message }: { href: string; children: ReactNode; className?: string; message?: string }) {
  const router = useRouter();
  const requireAuth = useAuthGate();
  const [pending, setPending] = useState(false);
  const activate = async (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (pending) return;
    setPending(true);
    await requireAuth(href, () => router.push(href), message);
    setPending(false);
  };
  return <a href={href} className={className} onClick={(event) => void activate(event)} aria-disabled={pending}>{children}</a>;
}
